import { render, staticRenderFns } from "./settings-lists.vue?vue&type=template&id=78ccf5d9&scoped=true&"
import script from "./settings-lists.ts?vue&type=script&lang=ts&"
export * from "./settings-lists.ts?vue&type=script&lang=ts&"
import style0 from "./settings-lists.vue?vue&type=style&index=0&id=78ccf5d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ccf5d9",
  null
  
)

export default component.exports